import { Typography } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const TypographyFooterFeatures = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 11,
    lineHeight: '19px',
    letterSpacing: '-0.02em',
    textAlign: 'center',
    color: '#000000',
    position:'relative',
    top: '75px'
  }
})(Typography);

const TypographyPriceTitle = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 20,
    lineHeight: '26px',
    letterSpacing: '-0.02em',
    textAlign: 'center',
    color: '#FFFFFF'
  }
})(Typography);

const TypographyFooterPriceValue = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 32,
    lineHeight: '41px',
    letterSpacing: '-0.02em',
    textAlign: 'center',
    color: '#CDDE00'
  }
})(Typography);

const GridPrice = withStyles({
  root: {
    background: '#237DA1',
  }
})(Grid);

export { TypographyFooterFeatures, TypographyPriceTitle, TypographyFooterPriceValue, GridPrice } 


// WEBPACK FOOTER //
// ./src/components/common/outbox/features/FeaturesStyled.js